import type { SchemaField } from '../../../../types/schede'
import FieldWrapper from './FieldWrapper'

interface DateFieldProps {
  field: SchemaField
  value: any
  onChange: (value: any) => void
  readOnly?: boolean
  error?: string
}

export default function DateField({ field, value, onChange, readOnly, error }: DateFieldProps) {
  return (
    <FieldWrapper field={field} error={error}>
      <input
        type="date"
        value={value ?? ''}
        onChange={(e) => onChange(e.target.value)}
        readOnly={readOnly}
        className="w-full px-2 py-1.5 text-sm border rounded outline-none focus:ring-1 focus:ring-blue-500"
        style={{
          backgroundColor: 'var(--color-bg-input, var(--color-bg-card))',
          borderColor: 'var(--color-border)',
          color: 'var(--color-text-primary)',
        }}
      />
    </FieldWrapper>
  )
}
